import { PARKS_SELECT } from './index';
import { Action } from '../action';
import { ParkInfo } from '@shared/core';

export class ParksSelectInitAction implements Action {
	readonly type = PARKS_SELECT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ParksSelectDestroyAction implements Action {
	readonly type = PARKS_SELECT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ParksSelectClickParkAction implements Action {
	readonly type = PARKS_SELECT.CLICK_PARK;
	constructor(
		public payload: ParkInfo,
		public correlationId?: number
	) {}
}
